/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /** cart code **/

var isCartPage = document.getElementById('your-shopping-cart');

// Function to check if the element is visible
function checkVisibility() {
    const cartDrawer = document.getElementById('cart-drawer');
    if ((cartDrawer && cartDrawer.offsetWidth > 0 && cartDrawer.offsetHeight > 0)||isCartPage) {
      if ( document.querySelector('.cart__total__money') ) {
        // Element is visible
        //console.log('Cart drawer is visible');
        // Trigger a custom event
        const event = new CustomEvent('cartDrawerVisible');
        document.dispatchEvent(event);
      }
    }
}

// Create a MutationObserver to monitor changes in the DOM
const observer = new MutationObserver(() => {
    checkVisibility();
});

// Start observing the body for added nodes
observer.observe(document.body, { childList: true, subtree: true });

// Listen for your custom event
document.addEventListener('cartDrawerVisible', function() {
    // Handle the event
    var cartTotal = parseFloat(document.querySelector('.cart__total__money').innerText.replace('$', '').replace(',', '').replace(' USD', ''));
    if ( cartTotal > 749.99 ) {
      document.getElementById('confirmation_label').style.display = 'flex';
    } else {
      document.getElementById('confirmation_label').style.display = 'none';
      document.getElementById('confirmation_warning').style.display = 'none';
    }
});




  
document.body.addEventListener('click', function(event) {
    if (event.target.matches('.cart__checkout.btn')) {
        
        var cartTotal = parseFloat(document.querySelector('.cart__total__money').innerText.replace('$', '').replace(',', '').replace(' USD', ''));
        var isChecked = document.getElementById('confirmation_checkbox').checked;
        
        if (cartTotal > 749.99 && !isChecked) {
            event.preventDefault();
            document.getElementById('confirmation_warning').style.display = 'flex';
            alert('Please confirm your understanding of the cart total before proceeding.');
        }
    }
});





  
  var isProductPage = document.querySelector('.product-single__wrapper');
  var isRepairProgramPage = document.querySelector('.repair-program-page');

  var lookBlocks = document.querySelectorAll('.look');
  if ( lookBlocks && lookBlocks.length > 0 ) {
    padLookBlocks();
  }
  window.addEventListener('resize', padLookBlocks);

  var accordionButtons = document.querySelectorAll('.product__accordion__title');

  if ( isProductPage && accordionButtons && accordionButtons.length > 0 ) {
    accordionButtons.forEach( function(item, index) {
      window.onload = function() {
        // Changed again 01/02/2024 - gp
        if ( item.textContent == 'Materials and specs' )
          item.click();
      };
    });
  }
  //isRepairProgramPage = false;

  if ( isRepairProgramPage ) {
    var theBtns = document.querySelectorAll('.image-with-text__items .btn, .text-section .text__button .btn');
    var theFormElement = document.getElementById('the-form').parentElement.parentElement;

    theBtns.forEach( function(item, index) {
      item.addEventListener('click', function(_e) {
        _e.preventDefault();

        if (theFormElement)
          theFormElement.scrollIntoView({ behavior: 'smooth' });

      });
    });
  }
  
  /** mobile add to cart close popup **/

  // Listen for the custom event
  document.addEventListener('theCartUpdated', function(e) {
    console.log('Custom event triggered:', e.detail);
  });
  // Store the original fetch function
  const originalFetch = window.fetch;
  
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(response => {
      // Check if the request is related to the cart
      if (response.url.includes('/cart/add.js') || response.url.includes('/cart/update.js')) {
        // Clone the response to avoid consuming the body stream
        response.clone().json().then(cart => {
          // Dispatch a custom event with the cart data
          const event = new CustomEvent('theCartUpdated', { detail: cart });
          //console.log('heyyyyyy');
          if ( document.querySelector('.popmechanic-mobile #shopify-section-api-quickview .popup-quick-view__form .product__form__wrapper .btn') ) {
            document.querySelector('.popmechanic-mobile #shopify-section-api-quickview .popup-quick-view__form .product__form__wrapper .popup-quick-view__close').click();
          }
        });
      }
      return response;
    });
  };
  


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


function padLookBlocks() {
  var lookBlocks = document.querySelectorAll('.look');
  lookBlocks.forEach( function(item, index) {
    if (window.innerWidth < 768)
      item.querySelector('.look__wrapper').style.paddingTop = (item.querySelector('.look__text').clientHeight+30)+'px';
    else
      item.querySelector('.look__wrapper').style.paddingTop = null;
  });
}